module.exports = "textarea {\n  resize: vertical;\n  margin-bottom: 5px;\n  margin-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-report-servicedesk/dialog-report-servicedesk.component.scss
// module id = ./src/app/shared/dialog-report-servicedesk/dialog-report-servicedesk.component.scss
// module chunks = main